import { externalThemePresets, externalThemeFamilies } from './external-theme-presets';

const existingPalettes = {
  // AI SALES by Andre Dorneles: https://tweakcn.com/themes/cmsoxvs9b000304job53594xk
  // Keep accessible link/on-gold roles and the approved system font/control sizes.
  'minimal-gold': {
    name: '极简暖金 · 浅色', description: 'AI SALES · 暖白背景 · 香槟金',
    primary: '#806333', primaryStrong: '#594626', accent: '#c8aa6e',
    accentLight: '#d7be8c', accentDark: '#b99a5d', buttonHighlight: '#f9f7f1', buttonShadow: '#211e17',
    ink: '#1a1a1a', text: '#1a1a1a', muted: '#6d6450', subtle: '#6d6450',
    canvas: '#f9f7f1', surface: '#ffffff', soft: '#f2eee0', border: '#e4dfc9',
    primarySoft: '#e6e2d4', inverse: '#ffffff', nav: '#f2eee0', navText: '#1a1a1a',
    success: '#594626', successSoft: '#e6e2d4', warning: '#594626', warningSoft: '#f2eee0', info: '#594626', infoSoft: '#e6e2d4',
    danger: '#a33e35', dangerSoft: '#f7e8e2', chart1: '#c8aa6e', chart2: '#3c4148', chart3: '#806333', chart4: '#8e7f5a', chart5: '#292d32',
  },
  'technology-gold': {
    name: '科技深金 · 深色', description: 'AI SALES · 深炭背景 · 香槟金',
    primary: '#dbbe84', primaryStrong: '#ecd5a7', accent: '#dbbe84',
    accentLight: '#ecd5a7', accentDark: '#c8aa6e', buttonHighlight: '#f9f7f1', buttonShadow: '#10100e',
    ink: '#f9f7f1', text: '#f9f7f1', muted: '#a49e93', subtle: '#a49e93',
    canvas: '#1b1b18', surface: '#1e1e1c', soft: '#242422', border: '#4c4b40',
    primarySoft: '#2d2b28', inverse: '#1b1b18', nav: '#1b1b18', navText: '#f9f7f1',
    success: '#ecd5a7', successSoft: '#2d2b28', warning: '#ecd5a7', warningSoft: '#242422', info: '#dbbe84', infoSoft: '#2d2b28',
    danger: '#f0a29a', dangerSoft: '#402925', chart1: '#dbbe84', chart2: '#6c7279', chart3: '#aca0c8', chart4: '#ac9d78', chart5: '#a49e93',
  },
} as const;

export const palettes = { ...existingPalettes, ...externalThemePresets } as const;
export type ThemeId = keyof typeof palettes;
export const themeFamilies = [
  { id: 'gold', name: 'AI SALES', light: 'minimal-gold', dark: 'technology-gold' },
  ...externalThemeFamilies,
] as const;
export const supportedThemeIds: readonly ThemeId[] = themeFamilies.flatMap(family => [family.light, family.dark]);
export function isDarkTheme(id: ThemeId) {
  return themeFamilies.some(family => family.dark === id);
}
export function oppositeTheme(id: ThemeId): ThemeId {
  const family = themeFamilies.find(family => family.light === id || family.dark === id) || themeFamilies[0];
  return family.dark === id ? family.light : family.dark;
}
export function themeOnAccent(id: ThemeId): string {
  const palette = palettes[id];
  return 'onAccent' in palette ? palette.onAccent : '#211e17';
}

export type ColorRole = Exclude<keyof typeof palettes['minimal-gold'], 'name' | 'description'>;
export const THEME_STORAGE_KEY = 'asset.ui-theme';
export function resolveTheme(value: unknown): ThemeId {
  if (typeof value === 'string' && supportedThemeIds.includes(value as ThemeId)) return value as ThemeId;
  // Retired appearance IDs migrate to the approved light mode.
  return 'minimal-gold';
}
